import { pick } from "~/core/i18n";

/** A platform version's issue, as the server names it, in words a person acts on. */
export function issueLabel(issue: string, locale: "en" | "zh") {
	const copy: Record<string, [string, string]> = {
		inline_image_conversion: [
			"This platform takes plain text: the article's pictures go as attachments instead of in place.",
			"该平台只收纯文本：文中的图片会改为附件发出，不在原位置。",
		],
		media_spec_review: [
			"Check media dimensions, file size and duration against the platform's current requirements.",
			"请按平台当前要求检查素材尺寸、文件大小和时长。",
		],
		media_required: ["This platform needs a picture or a video.", "该平台需要图片或视频。"],
		media_count: ["Too many attachments for this platform.", "附件数量超过该平台上限。"],
		media_type: ["This platform does not take one of the attachments' kinds.", "该平台不接受其中一种附件类型。"],

		platform_fields: ["Complete the platform's fields and destination.", "请补全平台字段和发布地址。"],
	};
	if (issue.startsWith("media_spec:"))
		return `${pick(locale, ["Media outside the platform's limits", "素材超出平台规格"])}: ${issue.split(":").slice(2).join(":")}`;
	if (copy[issue]) return pick(locale, copy[issue]);
	const [kind, field] = issue.split(":");
	const kinds: Record<string, [string, string]> = {
		length: ["Too long", "超出长度"],
		shortened: ["Shortened to fit", "已压缩至平台上限"],
	};
	return `${pick(locale, kinds[kind] ?? ["Required", "必填"])}: ${field ?? issue}`;
}
